angular.module("ainapp")
    .controller("otherRevenewLedgerController", ["app.config", "$scope", "$http", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", function (config, $scope, $http, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


        $scope.PageName = "Other Revenew Ledger";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }



        $scope.init = function () {

            $scope.Load = false;
            $scope.Error = 0;
            $scope.FromDateObject = null;
            $scope.ToDateObject = null;
            $scope.ViewVal = "Other Revenue Ledger";

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.filter = {
                FromDate: $scope.d2,
                ToDate: new Date(),
                DocNo: "",
            }

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.filter.FromDate = new Date($scope.finyear.StartDate);
            });

            $scope.AccFilter = {
                Keyword: "",
            }
            $scope.selectAll = false;

            $scope.GlLoad = false;
            $scope.AccLoad = false;


            $scope.GlData = [];

            $scope.IsHideCost = false;
        }
        $scope.init();


        //        $scope.PageName = "General Ledger";
        //        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        //        if ($scope.TokenInfo == null) {
        //            $state.go("login");
        //        } else {
        //            if ($scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
        //                var data = {
        //                    PageName: $scope.PageName,
        //                    UserId: $scope.TokenInfo.Id,
        //                }
        //                MainService.CheckUserPageAccess(data).then(function (response) {
        //                    if (response.data == true) {
        //                        $scope.init();
        //                    } else {
        //                        $state.go("forbidden");
        //                    }
        //                }, function (err) {
        //                    toastr.error("Network Error");
        //                });
        //            } else {
        //                $scope.init();
        //            }
        //        }

        $scope.changeView = function (val) {
            $scope.ViewVal = val;
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        }


        $scope.Filter = function () {
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        }

        $scope.Reset = function () {
            $scope.init();
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        }

        $scope.glGridDataSource = new kendo.data.DataSource({
            transport: {
                read: function (o) {
                    o.data.FromDate = $scope.filter.FromDate;
                    o.data.ToDate = $scope.filter.ToDate;
                    o.data.DocNo = $scope.filter.DocNo;
                    o.data.Type = $scope.ViewVal;

                    o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                    o.data.FromDay = $scope.filter.FromDate.getDate();
                    o.data.FromYear = $scope.filter.FromDate.getFullYear();

                    o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                    o.data.ToDay = $scope.filter.ToDate.getDate();
                    o.data.ToYear = $scope.filter.ToDate.getFullYear();

                    var data = JSON.stringify(o.data);

                    $http.post(config.basePath + "OtherRevenewGLInView", data).then(function (response) {
                        var data = {
                            Data: response.data.Data,
                            Total: response.data.Total
                        };
                        o.success(data);
                        $scope.GlData = response.data.Data;
                    }, function (err) {
                        o.success({
                            Data: []
                        });
                        toastr.error("Some Error Occured");
                    })
                }
            },
            change: function (data) {
                if (data.items.length > 0) {
                    data.sender._aggregateResult.BalanceAmount.count = 0;
                    angular.forEach(data.items, function (e) {
                        e.aggregates.BalanceAmount.count = Math.abs(e.aggregates.Debit.sum - e.aggregates.Credit.sum);
                        e.aggregates.BalanceAmount.count = Math.round(e.aggregates.BalanceAmount.count * 100) / 100;
                    })
                    data.sender._aggregateResult.BalanceAmount.count = Math.abs(data.sender._aggregateResult.Debit.sum - data.sender._aggregateResult.Credit.sum);
                    data.sender._aggregateResult.BalanceAmount.count = Math.round(data.sender._aggregateResult.BalanceAmount.count * 100) / 100;
                }
            },
            schema: {
                data: "Data",
                total: "Total",
                model: {
                    id: "Id",
                    fields: {
                        "Account.Name": {
                            type: "string",
                        },
                        "CostCenter1.Name": {
                            type: "string",
                        },
                        "CostCenter2.Name": {
                            type: "string",
                        },
                        "CostCenter3.Name": {
                            type: "string",
                        },
                        AccountId: {
                            type: "number",
                        },
                        Remarks: {
                            type: "string",
                        },
                        Type: {
                            type: "string",
                        },
                        Debit: {
                            type: "number",
                        },
                        Credit: {
                            type: "number",
                        },
                        BalanceAmount: {
                            type: "number",
                        },
                        Date: {
                            type: "date",
                        },
                        VoucherNumber: {
                            type: "string",
                        },
                    },
                }
            },
            group: [{
                field: "Account.Name",
                aggregates: [
                    {
                        field: "Debit",
                        aggregate: "sum"
                            },
                    {
                        field: "Credit",
                        aggregate: "sum"
                            }, {
                        field: "BalanceAmount",
                        aggregate: "count"
                            }
                        ]
                    }],
            aggregate: [{
                    field: "Debit",
                    aggregate: "sum"
                    },
                {
                    field: "Credit",
                    aggregate: "sum"
                        }, {
                    field: "BalanceAmount",
                    aggregate: "count"
                        }],
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            //serverGrouping: true,
        });
        $scope.glGridOptions = {
            //            stretch: true,
            //            height: 700,
            //            resizable: true,
            //            groupable: false,
            //            toolbar: ["excel", "pdf"],
            //            dataSource: $scope.glGridDataSource,
            //            dataBound: onDataBound,
            //            selectable: true,
            //            pageable: {
            //                input: false,
            //                refresh: true,
            //                pageSizes: true,
            //                info: true,
            //            },
            //
            //            filterable: false,

            stretch: true,
            toolbar: ["excel", "pdf"],
            dataBound: onDataBound,
            selectable: true,
            editable: false,
            pageable: true,
            toolbar: ["excel"],
            height: 700,
            resizable: true,
            dataSource: $scope.glGridDataSource,
            pageSize: 20,
            pageable: {
                input: false,
                refresh: true,
                pageSizes: true,
                info: true,
            },
            sortable: true,
            scrollable: true,
            filterable: true,
            groupable: true,
            columnMenu: {
                filterable: false,
                filterable: true,
            },

            columns: [
                {
                    field: "Account.Name",
                    hidden: true,

                    groupHeaderTemplate: "Account : #= value #",
                        },
                {
                    field: "Date",
                    title: "Date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    headerTemplate: "{{LanguageData.date}}",
                    },
                {
                    field: "VoucherNumber",
                    title: "Voucher #",
                    headerTemplate: "{{LanguageData.voucher}}",
                        },
                {
                    field: "Type",
                    title: "Type",
                    width: "200px",
                    headerTemplate: "{{LanguageData.type}}",
                    },
                {
                    field: "Remarks",
                    title: "Remarks",
                    width: "300px",
                    headerTemplate: "{{LanguageData.remarks}}",
                    },
//                {
//                    field: "Id",
//                    title: "Id",
//                        },
                {
                    field: "Debit",
                    format: "{0:n4}",
                    title: "Debit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "#=kendo.toString(sum, 'n')#",
                    //                    headerTemplate: "{{LanguageData.debit}}",
                        },
                {
                    field: "Credit",
                    title: "Credit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "#=kendo.toString(sum, 'n')#", //                    headerTemplate: "{{LanguageData.credit}}",
                        },
                {
                    field: "BalanceAmount",
                    title: "Balance",
                    template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "#=kendo.toString(sum, 'n')#", //                    headerTemplate: "{{LanguageData.balance}}",
                    },
                {
                    field: "CostCenter1.Name",
                    title: "Cost Center 1",
                    hidden: $scope.IsHideCost,
                    headerTemplate: "{{LanguageData.costcenter1}}",
                    },
                {
                    field: "CostCenter2.Name",
                    title: "Cost Center 2",
                    hidden: $scope.IsHideCost,
                    headerTemplate: "{{LanguageData.costcenter2}}",
                    },
                {
                    field: "CostCenter3.Name",
                    title: "Cost Center 3",
                    hidden: $scope.IsHideCost,
                    headerTemplate: "{{LanguageData.costcenter3}}",
                    },
                    ]
        };


        $scope.print = function () {

            $scope.filter.IsFilter = $scope.filter.IsFilter;
            $scope.filter.Accounts = $scope.filter.Accounts;
            $scope.filter.FromDate = $scope.filter.FromDate;
            $scope.filter.ToDate = $scope.filter.ToDate;
            $scope.filter.DocNo = $scope.filter.DocNo;

            $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

            $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

            MainService.PrintGeneralLedgerReport($scope.filter).then(function (response) {
                if (response.data != null) {
                    $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                } else {
                    toastr.error("Network Error");
                }
                $scope.Load = false;
            }, function (err) {
                toastr.error("Network Error");
                $scope.Load = false;
            })
        }


        function onDataBound() {
            var grid = this;
            grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                $scope.GetVoucherDetailsInGL();
            })
        }

        $scope.GLData = {};
        $scope.VoucherData = {};
        $scope.GetVoucherDetailsInGL = function () {

            $scope.VoucherData = {};

            grid = $("#gl-master-grid").data("kendoGrid");
            $scope.GLData = grid.dataItem(grid.select());

            MainService.GetVoucherDetailsInGL($scope.GLData.Id).then(function (response) {
                    if (response) {
                        $scope.VoucherData = response.data;
                        $('#voucherModal').modal('show');
                    }
                },
                function (err) {
                    toastr.error("Network Error");
                });

        }



  }]);
